import generalInit from './modules/general';
import slidersInit from './modules/sliders';
import menuInit from './modules/menu';
import galleryInit from './modules/wp-gallery';
import loadMoreInit from './modules/loadmore';

import ScrollBoxInit from './modules/scroll-box';
import ScrollNavInit from './modules/scroll-nav';
import FixedNavInit from './modules/fixed-nav';
import ParallaxInit from './modules/parallax';
// import PerspectiveBoxInit from './modules/perspective-box';
import StickyInit from './modules/sticky';
import FixtoInit from './modules/fixto';
import DropdownInit from './modules/dropdown';
// import ScrollAnimateInit from './modules/scroll-animate';
import TabsInit from './modules/tabs';
import TimelineInit from './modules/timeline';
import TooltipInit from './modules/tooltip';
import matcheHeightInit from './modules/match-height';
import formInit from './modules/forms';
import googleMapInit from './modules/google-map';


(function ($) {

	setTimeout(() => {
		$('body').addClass('is-loaded');
		$(window).trigger('resize').trigger('scroll');

	}, 100);

	$(window).on('load', function () {
		$(window).trigger('resize').trigger('scroll');

		setTimeout(() => {
			$(window).trigger('resize').trigger('scroll');
		}, 500);
	});

	$(document).foundation();

	$(document).ready(function () {

		generalInit();
		slidersInit();
		menuInit();
		galleryInit();
		loadMoreInit();
		TabsInit();
		FixedNavInit();
		TimelineInit();
		matcheHeightInit();
		formInit();
		googleMapInit();

		new ScrollBoxInit();
		new ScrollNavInit();
		new ParallaxInit();
		new DropdownInit();
		// new PerspectiveBoxInit();
		new StickyInit();
		new FixtoInit();
		// new ScrollAnimateInit();
		new TooltipInit();

		$(document).trigger('hp-plugins-loaded');

	});

})(jQuery);